import React from 'react';
import { Content, Main, Wrapper } from './Overview.styles';
import { Persona } from './components/Persona/Persona';
import {
  BEFI20_DISABLE_ERROR_REGEX,
  BEFI20_NOT_COMPLETED_ERROR_REGEX,
  useOverviewQuery,
} from '../api/useOverviewQuery';
import { ErrorState } from '../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Alignments } from './components/Alignments/Alignments';
import { ShareSection } from './components/ShareSection/ShareSection';
import { useDocumentTitle } from '../../_hooks/useDocumentTitle';
import { Alert } from '../../CommonComponents/OPL/Alert/Alert';
import { Box } from '../../CommonComponents/OPL/Box/Box';
import { BeFi20Logo } from '../img/BeFi20Logo';
import { LoadingScreen } from '../Survey/components/LoadingScreen/LoadingScreen';

export const Overview = () => {
  useDocumentTitle('BeFi20 Overview');

  const { isLoading, isError, error, refetch, data } = useOverviewQuery();

  if (isLoading) {
    return <LoadingScreen text="Loading Your Financial Persona" shouldAnimate={false} />;
  }

  if (isError) {
    if (
      BEFI20_DISABLE_ERROR_REGEX.test(error.message) ||
      BEFI20_NOT_COMPLETED_ERROR_REGEX.test(error.message)
    ) {
      return (
        <Wrapper>
          <Box maxWidth={1000} mx="auto" mt="32" px="16">
            <Alert variant="error" message={error.message} />
          </Box>
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <ErrorState onAction={refetch} css="height: 100%" />
      </Wrapper>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <Wrapper>
      <Content initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
        <BeFi20Logo />

        <Main as="main">
          <Persona data={data} />

          <Alignments data={data} />

          <ShareSection />
        </Main>
      </Content>
    </Wrapper>
  );
};
